<template>
  <my-view :PageOrderPay="PageOrderPay" :GetOrderPayState="GetOrderPayState" :PtPageOrderPay="PtPageOrderPay" :SinglePageOrderPay="SinglePageOrderPay"></my-view>
</template>

<script>
import {
  PageOrderPay,
  GetOrderPayState,
  PtPageOrderPay,
  SinglePageOrderPay,
} from "@/pages/page1/api/modules/order";

import MyView from "@/pages/publicView/paymentProcess/WechatPay_view.vue";

export default {
  components: { MyView },
  data() {
    return {
      PageOrderPay,
      GetOrderPayState,
      PtPageOrderPay,
      SinglePageOrderPay,
    };
  },
};
</script>